module.exports = "/_next/static/images/game-1-phone-uv-lock-4-bc1520229b88785ac21d6530969654f5.png";